<script setup>
import { computed } from "vue";

const props = defineProps({
  size: {
    type: String,
    default: "medium",
    validator: (value) => ["extra-small", "small", "medium", "large"].includes(value)
  },
  pressed: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  iconOnly: {
    type: Boolean,
    default: false
  }
});

const buttonClasses = computed(() => [
  "button-neutral-secondary",
  `button-neutral-secondary--${props.size}`,
  {
    "button-neutral-secondary--icon-only": props.iconOnly,
    "button-neutral-secondary--pressed": props.pressed
  }
]);
</script>

<template>
  <button
    :disabled="props.disabled"
    :class="buttonClasses"
    :aria-pressed="props.pressed ? 'true' : 'false'"
    type="button"
  >
    <slot name="icon-left" />
    <slot />
    <slot name="icon-right" />
  </button>
</template>

<style scoped lang="scss">

.button-neutral-secondary {
  // Сброс дефолтных стилей.
  border: none;
  outline: none;
  background: none;
  margin: 0;
  font: inherit;

  // Стили кнопки.
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  padding: 6px 15px;
  background: var(--button-secondary-neutral-default);
  color: var(--button-secondary-neutral-default-text);
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;

  cursor: pointer;
  user-select: none;

  // Если кнопка содержит только иконку - убираем отступы, задаем ширину равной высоте.
  &--icon-only {
    padding: 0;
    min-width: var(--button-height);
    width: var(--button-height);
  }

  // Состояния

  &:hover:not(:disabled):not(&--pressed) {
    color: var(--button-secondary-neutral-hover-text);
    background: var(--button-secondary-neutral-hover);
  }

  &:focus-visible {
    outline: 2px solid var(--button-secondary-neutral-bd-focused);
    outline-offset: 2px;
  }

  &:disabled {
    pointer-events: none;
    background: var(--button-secondary-neutral-disabled);
    color: var(--text-text-disabled);
  }

  &--pressed {
    pointer-events: none;
    background: var(--button-secondary-neutral-pressed);
    color: var(--button-secondary-neutral-pressed-text);
  }


  // Размеры
  &--extra-small {
    --button-height: 24px;
    height: var(--button-height);
    min-height: var(--button-height);
  }

  &--small {
    --button-height: 30px;
    height: var(--button-height);
    min-height: var(--button-height);
  }

  &--medium {
    --button-height: 36px;
    height: var(--button-height);
    min-height: var(--button-height);
  }

  &--large {
    --button-height: 42px;
    height: var(--button-height);
    min-height: var(--button-height);
  }
}

</style>